export const transformTierDetailsResponse = (response) => {
  if (!response?.content || typeof response.content !== 'object') {
    return response;
  }

  const transformedContent = {};
  for (const [key, value] of Object.entries(response.content)) {
    const transformedKey = key.replace(/-/g, '_');
    transformedContent[transformedKey] = value;
  }

  return {
    ...response,
    content: transformedContent
  };
};
